// Helpers shared by the bell dropdown, the /notifications page, and the
// Settings → Notifications page.

// Keep in sync with backend notifications/store.py KINDS.
export const NOTIFICATION_KINDS = [
  "invite_received",
  "task_assigned",
  "task_overdue",
  "workflow_completed",
  "workflow_errored",
  "document_declined",
  "document_expired",
];

export const KIND_LABELS = {
  invite_received: "Приглашение",
  task_assigned: "Задача назначена",
  task_overdue: "Задача просрочена",
  workflow_completed: "Процесс завершён",
  workflow_errored: "Ошибка процесса",
  document_declined: "Документ отклонён",
  document_expired: "Срок подписания истёк",
  message_received: "Новое сообщение",
};

export const PREF_LABELS = {
  email_invite: "Приглашения в организации",
  email_task_assigned: "Новая задача мне",
  email_task_overdue: "Просрочка моей задачи",
  email_workflow_completed: "Завершение запущенного процесса",
  email_workflow_errored: "Ошибки процессов (для админов)",
  email_document_declined: "Отклонение моего документа",
  email_document_expired: "Истечение срока подписания",
};

export const DEFAULT_NOTIFICATION_PREFS = {
  email_invite: true,
  email_task_assigned: true,
  email_task_overdue: true,
  email_workflow_completed: true,
  email_workflow_errored: true,
  email_document_declined: true,
  email_document_expired: true,
};

export function notificationTitle(n) {
  const k = n?.kind;
  const p = n?.payload || {};
  switch (k) {
    case "invite_received":
      return `Приглашение в организацию${
        p.role ? ` · роль «${p.role}»` : ""
      }`;
    case "task_assigned":
      return "Вам назначена задача";
    case "task_overdue":
      return "Задача просрочена";
    case "workflow_completed":
      return `Процесс «${p.workflow_name || "без названия"}» завершён`;
    case "workflow_errored":
      return `Ошибка в процессе «${p.workflow_name || "без названия"}»`;
    case "document_declined":
      return `Документ «${p.title || "без названия"}» отклонён${
        p.declined_by ? ` (${p.declined_by})` : ""
      }`;
    case "document_expired":
      return `Истёк срок подписания «${p.title || "без названия"}»`;
    case "message_received":
      return `Новое сообщение${p.from ? ` от ${p.from}` : ""}${
        p.title ? ` · «${p.title}»` : ""
      }`;
    default:
      return "Уведомление";
  }
}

export function formatRelativeTime(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    const now = Date.now();
    const diffSec = Math.floor((now - d.getTime()) / 1000);
    if (diffSec < 60) return "только что";
    const diffMin = Math.floor(diffSec / 60);
    if (diffMin < 60) return `${diffMin} мин назад`;
    const diffHr = Math.floor(diffMin / 60);
    if (diffHr < 24) return `${diffHr} ч назад`;
    const diffDay = Math.floor(diffHr / 24);
    if (diffDay < 7) return `${diffDay} дн назад`;
    return d.toLocaleDateString("ru-RU", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}
